import { useState } from "react";
import { updateBadgeForm } from "../../lib/actions";
import { useTranslation } from "react-i18next";
import { FiUploadCloud } from "react-icons/fi";
import { MdOutlineDeleteOutline } from "react-icons/md";

export default function EditBadgeUi({ data, handleApi }) {
    const [loading, setLoading] = useState(false);
    const [isActive, setIsActive] = useState(Number(data.is_active) === 1);
    const [iconPreview, setIconPreview] = useState(data.icon || null);

    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const formData = new FormData(e.target);
        // formData.append("is_active", isActive ? "1" : "0");
        
        // Ensure empty files don't override the existing icon if not selected
        if (!e.target.icon.files[0]) {
            formData.delete("icon");
        }

        const result = await updateBadgeForm(formData);
        if(result) {
            handleApi();
        }
        setLoading(false);
    };

    const handleIconChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (iconPreview && iconPreview.startsWith("blob:")) {
                URL.revokeObjectURL(iconPreview);
            }
            setIconPreview(URL.createObjectURL(file));
        }
    };

    const handleDeleteIcon = () => {
        if (iconPreview && iconPreview.startsWith("blob:")) {
            URL.revokeObjectURL(iconPreview);
        }
        setIconPreview(null);
        // Clear the hidden file input so the user can re-upload the same file if needed
        const fileInput = document.getElementById("badge-icon-upload");
        if (fileInput) fileInput.value = "";
    };

    const getField = (field, lang) => {
        if (data && data[field] && typeof data[field] === 'object') {
            return data[field][lang] || "";
        }
        return ""; 
    };

    return (
        <form onSubmit={handleSubmit} className="">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                
                <div className="mb-4">
                    <label className="block text-white mb-2">{t("form.title_en") || "Title (EN)"}</label>
                    <input type="text" name="title[en]" defaultValue={getField('title', 'en')} className="w-full px-4 py-2 bg-thirdly border border-gray-500/50 text-white rounded-lg focus:border-secondary outline-none" required />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{t("form.title_ar") || "Title (AR)"}</label>
                    <input type="text" name="title[ar]" defaultValue={getField('title', 'ar')} className="w-full px-4 py-2 bg-thirdly border border-gray-500/50 text-white rounded-lg focus:border-secondary outline-none text-right" required />
                </div>
{/* 
                <div className="mb-4 col-span-1 md:col-span-2">
                    <label className="block text-white mb-2">{t("form.description_en") || "Description (EN)"}</label>
                    <textarea name="description[en]" defaultValue={getField('description', 'en')} rows="3" className="w-full px-4 py-2 bg-thirdly border border-gray-500/50 text-white rounded-lg focus:border-secondary outline-none"></textarea>
                </div>
                <div className="mb-4 col-span-1 md:col-span-2">
                    <label className="block text-white mb-2">{t("form.description_ar") || "Description (AR)"}</label>
                    <textarea name="description[ar]" defaultValue={getField('description', 'ar')} rows="3" className="w-full px-4 py-2 bg-thirdly border border-gray-500/50 text-white rounded-lg focus:border-secondary outline-none text-right"></textarea>
                </div> */}

                <div className="mb-4">
                    <label className="block text-white mb-2">{t("form.start_date") || "Start Date"}</label>
                    <input type="date" name="start_date" defaultValue={data.start_date} className="w-full px-4 py-2 bg-thirdly border border-gray-500/50 text-white rounded-lg focus:border-secondary outline-none" required />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{t("form.registration_limit_date") || "Registration Limit Date"}</label>
                    <input type="date" name="registration_limit_date" defaultValue={data.registration_limit_date} className="w-full px-4 py-2 bg-thirdly border border-gray-500/50 text-white rounded-lg focus:border-secondary outline-none" required />
                </div>
                
                <div className="mb-4">
                    <label className="block text-white mb-2">{t("form.limit_count") || "Limit Count"}</label>
                    <input type="number" name="limit_count" defaultValue={data.limit_count} className="w-full px-4 py-2 bg-thirdly border border-gray-500/50 text-white rounded-lg focus:border-secondary outline-none" required />
                </div>

                {/* --- PRO ICON UPLOAD AREA --- */}
                <div className="col-span-1 md:col-span-2 mb-4">
                    <label className="block text-white mb-2">{t("form.icon") || "Icon"}</label>
                    <div className="bg-thirdly p-4 rounded-2xl border-2 border-dashed border-gray-500/50 hover:border-secondary transition-colors h-48 flex flex-col justify-center items-center relative group w-full lg:w-1/2">
                        
                        {/* Always keep the input mounted so e.target.icon exists on submit */}
                        <input
                            type="file"
                            name="icon"
                            id="badge-icon-upload"
                            accept="image/*"
                            className={`absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10 ${iconPreview ? 'hidden' : 'block'}`}
                            onChange={handleIconChange}
                        />

                        {!iconPreview ? (
                            <div className="text-center w-full h-full flex flex-col items-center justify-center pointer-events-none">
                                <FiUploadCloud className="w-10 h-10 text-gray-400 mb-2 group-hover:text-secondary transition-colors" />
                                <span className="text-sm text-gray-300 group-hover:text-white transition-colors">
                                    {currentLang === "en" ? "Click to upload icon" : "انقر لرفع الأيقونة"}
                                </span>
                            </div>
                        ) : (
                            <div className="relative w-full h-full flex justify-center items-center">
                                <img
                                    src={iconPreview}
                                    alt="Icon Preview"
                                    className="h-full w-auto object-contain rounded-lg"
                                />
                                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex justify-center items-center rounded-lg z-20">
                                    <button
                                        type="button"
                                        onClick={handleDeleteIcon}
                                        className="bg-red-500 text-white p-3 rounded-full shadow-lg hover:bg-red-600 transition-colors"
                                    >
                                        <MdOutlineDeleteOutline className="w-6 h-6" />
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* <div className="mb-4 col-span-1 md:col-span-2 flex flex-col sm:flex-row gap-8 mt-2">
                    <div className="flex items-center justify-between bg-thirdly p-4 rounded-xl border border-white/5 w-full sm:w-1/2">
                        <span className="text-white font-medium">{t("form.is_active") || "Is Active"}</span>
                        <label className="relative inline-flex items-center cursor-pointer">
                            <input 
                                type="checkbox" 
                                checked={isActive}
                                onChange={(e) => setIsActive(e.target.checked)}
                                className="sr-only peer" 
                            />
                            <div className="w-11 h-6 bg-gray-600 rounded-full peer peer-focus:ring-4 peer-focus:ring-secondary/30 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-secondary"></div>
                        </label>
                    </div>
                </div> */}
            </div>

            <div className="flex justify-center w-full mt-8">
                <button type="submit" disabled={loading} className={`w-full md:w-1/3 bg-secondary text-white py-3 rounded-xl font-semibold shadow-lg transition hover:bg-orange-600 ${loading ? "cursor-not-allowed opacity-70" : "" }`} >
                    {loading ? (
                        <div className="flex items-center justify-center gap-2">
                             <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                            </svg>
                            {currentLang === "en" ? "Saving..." : "جاري الحفظ..."}
                        </div>
                    ) : 
                        t("button.save", "Save")
                    }
                </button>
            </div>
        </form>
    );
};